import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_garagespot/artifacts/9v94qfyu_ik2eevmn_E97AFB72-AE7D-42EF-9C28-41681E1BB841.png";

// Logo component with PNG image
export default function Logo({ className = "h-24" }) {
  return (
    <Link to="/" className="flex items-center" data-testid="logo-link">
      <img 
        src={LOGO_URL} 
        alt="Plazafy" 
        className={className}
        style={{ objectFit: 'contain' }}
      />
    </Link>
  );
}

// Logo only icon (for places where we need just the icon)
export function LogoIcon({ className = "h-10 w-10" }) {
  return (
    <img 
      src={LOGO_URL} 
      alt="Plazafy" 
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}

// Export the URL for direct use
export { LOGO_URL };
